import http from "@/http";
import {notifyError, notifySuccess} from "@/components/composables/messages";

export const state = {
    listAll: {},
    listCards: [],
    pagination: {
        page: 1,
        limit: 25,
        total: 1,
        partial: 0,
    },
    showModalForm: false,
    submitted: false,
    loading: false,
}

export const mutations = {
    getList(state, newValue) {
        state.listAll = newValue.data;

        const isLaravel = Object.prototype.hasOwnProperty.call(newValue, 'meta');

        state.pagination = {
            page: isLaravel ? newValue.meta.current_page : newValue.page,
            pages: isLaravel ? newValue.meta.last_page : newValue.pages,
            limit: isLaravel ? newValue.meta.per_page : newValue.per_page,
            total: isLaravel ? newValue.meta.total : newValue.count,
            start: isLaravel ? newValue.meta.from : (newValue.count > 0 ? newValue.page * newValue.per_page + 1 : 0),
            partial: isLaravel ? newValue.meta.to : (newValue.count > 0 ? newValue.page * newValue.per_page + newValue.data.length : 0),
        }
    },

    getValues(state, newValue) {
        state.listAll = newValue
    },

    resetValues(state) {
        state.listAll = null;
        state.listCards = [];
    },

    setPagination(state, value) {
        state.pagination = value;
    },

    startLoading(state) {
        state.loading = true;
    },

    startSubmit(state) {
        state.submitted = true;
    },

    endSubmit(state) {
        state.submitted = false;
    },

    startProcessing(state) {
        state.loading = true;
        state.submitted = true;
    },

    endProcessing(state) {
        state.loading = false;
        state.submitted = false;
    },

    endLoading(state) {
        state.loading = false;
    },

    changeShowModalForm(state, value) {
        state.showModalForm = value;
    }
}

export const actions = {
    // eslint-disable-next-line no-unused-vars
    init({state, dispatch}) {
        dispatch('validate')
    },

    getApi({commit}, session) {
        const obj = JSON.parse(localStorage.getItem(session));

        http.get(obj.url, {
                params: {
                    ...obj.params
                }
            })
            .then(response => {
                commit('getList', response.data);
            })
            .catch(error => {
                console.error('store - getApi: ', error);
                notifyError(error.response);
            })
    },

    getCards({commit}, url) {
        if (document.getElementById('spinnerTable')) document.getElementById('spinnerTable').style.display = 'block';
        http.get(url, {
                headers: {'Authorization': ` Bearer ${localStorage.getItem('token')} `}
            })
            .then(response => {
                commit('getCards', response.data);
            })
            .catch(error => {
                console.error('store - getCards: ', error);
                notifyError(error.response);
            })
    },

// eslint-disable-next-line
    async insert({dispatch, commit}, data) {
        commit('startSubmit');
        commit('startLoading');
        let url = data.url;
        let formData = data.formData;
        if (formData.id > 0) {
            url += `/${formData.id}`;
            formData._method = 'PUT';
            delete formData.password;
        }
        return await http.post(url, formData, {
                headers: {'Authorization': ` Bearer ${localStorage.getItem('token')} `}
            })
            .then((response) => {
                notifySuccess(response.data.message);
                setTimeout(() => {
                    commit('endProcessing');
                }, 200)
                return true;
            })
            .catch(error => {
                console.error('store - insert: ', error);
                notifyError(error.response);
                setTimeout(() => {
                    commit('endLoading');
                }, 200)
                return false;
            })
    },

    async delete({dispatch}, data) {
        const session = JSON.parse(localStorage.getItem(data.session));
        const id = data.id;
        const route = session.url.replace(/\/+$/, '');
        let url = `${route}/${id}`;
        return await http.delete(url, {
                headers: {'Authorization': ` Bearer ${localStorage.getItem('token')}`}
            })
            .then((response) => {
                dispatch('getApi', data.session);
                notifySuccess(response.data.message);
            })
            .catch(error => {
                console.error('store - delete: ', error);
                notifyError(error.response);
            })
    }
}
